module.exports = __webpack_public_path__ + "img/zip.f82fddc1.svg";